<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-card-title>
            <v-btn icon @click="goToProgramView">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            {{ title }} {{ programInfo.name }}
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        
        <!-- <v-progress-linear indeterminate color="yellow darken-2" v-if="loading"></v-progress-linear> -->

        <!-- Dialog for confirm update user -->
        <v-dialog v-model="dialogConfirmMember" max-width="400px">
            <v-card>
                <v-card-title class="text">ยืนยันคุณสมบัติของผู้เข้าร่วมโปรแกรม?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogConfirmMember=false">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="submit">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog for confirm update user -->
        <v-dialog v-model="dialog" max-width="400px">
            <v-card>
                <v-card-title class="text">Done!</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="getUserList">OK</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-data-table :headers="headers" :items="userList" :search="search" sort-by="name" item-class="cellClass" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options" :loading="isLoading">
            <template v-slot:[`item.avatar`]="{ item }">
                <v-avatar v-if="item.pictureUrl" size="32" class="mr-2">
                    <img :src="item.pictureUrl" />
                </v-avatar>
                <v-avatar v-if="!item.pictureUrl" color="info" size="32" class="mr-2">
                    <v-icon dark> mdi-account-circle </v-icon>
                </v-avatar>
            </template>
            <template v-slot:[`item.programName`]="{ item }">
                <v-icon color="red" v-if="!item.currentProgram && item.uid != loggedInUserId"></v-icon>
                <v-icon color="green" v-else-if="item.currentProgram == id"> mdi-checkbox-marked-outline</v-icon>
                <v-icon color="red" v-else> mdi-checkbox-marked-outline</v-icon>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-btn small color="primary" @click="showConfirmPopup(item)" v-if="item.allowAdd && (!item.currentProgram && loggedInUserId!=item.uid)">Add</v-btn>
            </template>
        </v-data-table>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import {
    mapGetters
} from "vuex";
import formatData from "../utils/formatData";
import setProgramInfo from "../data/setProgramInfo";
import getProgramInfoById from "../data/getProgramInfoById";
import bqGetUserByCoachId from "../data/bqGetUserByCoachId";
export default {
    name: 'ProgramManagementMember',
    metaInfo: {
        title: 'Program Management Member'
    },
    data() {
        return {
            select: null,
            search: null,
            loading: false,
            options: {
                itemsPerPage: 20,
            },
            headers: [{
                    text: "",
                    value: "avatar",
                    sortable: false,
                },
                {
                    text: "Member Name",
                    value: "name",
                    cellClass: "pr-0",
                },
                {
                    text: "Group Name",
                    value: "groupName",
                    cellClass: "pr-0",
                },
                {
                    text: "Phone Number",
                    value: "phoneNumber",
                    cellClass: "pr-0",
                },
                {
                    text: "Current Program",
                    value: "programName",
                    cellClass: "pr-0",
                    sortable: false,
                    align: 'center'
                },
                {
                    text: "Actions",
                    value: "actions",
                    sortable: false,
                    align: 'center'
                },
            ],
            userList: [],
            defaultItem: {
                name: ""
            },
            dialog: false,
            title: "เพิ่มสมาชิกเข้าโปรแกรม ",

            dialogConfirmMember: false,
            programInfo: {},
            selectedUID: 0,
            selectedGroupID: 0,
            isLoading: false
        };
    },

    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Coach Program";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.isLoading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
        this.id = this.$route.params.id;
    },
    computed: {
        ...mapGetters([
            "isAuthenticated",
            "loggedInUserId",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessCoachAdmin"
        ]),
    },
    watch: {
        dialog(val) {
            val || this.close();
        }
    },
    methods: {
        initialize() {
            if (this.isAccessCoachAdmin) {
                (async () => {
                    this.programInfo = await getProgramInfoById(this.id);
                    this.getUserList();
                    this.isLoading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        getUserList(uid) {
            (async () => {
                const userList = await bqGetUserByCoachId(this.programInfo.owner, this.id);
                
                const userArray = [];
                this.userList = [];

                userList.forEach((user) => {
                    if (userArray[user.uid] == undefined) {
                        if( uid != undefined && user.uid == uid ){
                            user['currentProgram'] = this.id;
                        }
                        if( user['currentProgram'] ){
                            user['programName'] = 'yes';
                        }

                        this.userList.push(user);
                        userArray[user.uid] = 1;
                    }
                });
            })();
            this.dialog = false;
        },
        showConfirmPopup(item) {
            if( !this.isLoading ){
                this.selectedUID = item.uid;
                this.selectedGroupID = item.groupId;
                this.dialogConfirmMember = true;
            }
        },
        submit() {
            (async () => {
                this.dialogConfirmMember = false;
                (async () => {
                    this.isLoading = true;
                    await setProgramInfo({
                            action: 'addMember',
                            groupId: this.selectedGroupID,
                            addedBy: this.loggedInUserId
                        },
                        this.id,
                        this.selectedUID
                    );
                    this.dialog = true;

                    await this.getUserList(this.selectedUID);  
                    
                    this.selectedUID = 0;
                    this.selectedGroupID = 0;
                    this.isLoading = false;
                })();
            })();
        },
        close() {
            this.dialog = false;                  
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        goToProgramView() {
            this.$router.push(`/program/${this.$route.params.mod}/view/${this.id}`);
        },
    },
};
</script>
